import { apiURL } from "./constants";
import axios from "axios";


export async function getReceiverDetails(params = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/receiver_details/`, {
        params,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function getReceiverDetail(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/receiver_details/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function createReceiverDetail(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.post(`${apiURL}/api/receiver_details/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response; 
}

export async function updateReceiverDetail(id, payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.patch(`${apiURL}/api/receiver_details/${id}/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function deleteReceiverDetail(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.delete(`${apiURL}/api/receiver_details/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

/**
 * Export receiver details to Excel.
 * Mode A — selected rows: pass `ids` array in body.
 * Mode B — filtered list: omit `ids` and pass the same query params as the list API via `params`.
 */
export async function exportReceiverDetailsToExcel({ ids, params } = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const config = {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
    };
    const hasIds = Array.isArray(ids) && ids.length > 0;
    if (hasIds) {
        return axios.post(`${apiURL}/api/receiver_details/export-excel/`, { ids }, config);
    }
    const query = new URLSearchParams();
    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                query.set(key, String(value));
            }
        });
    }
    const qs = query.toString();
    const url = qs
        ? `${apiURL}/api/receiver_details/export-excel/?${qs}`
        : `${apiURL}/api/receiver_details/export-excel/`;
    return axios.post(url, {}, config);
}

